'use client';

import { CurrentRatioValues } from './types';
import { ToolsTranslations } from '@/lib/translations/types';

interface Props {
  values: CurrentRatioValues;
  onValuesChange: (field: keyof CurrentRatioValues, value: number) => void;
  translations: ToolsTranslations['currentRatio'];
}

export default function CalculatorInputs({ values, onValuesChange, translations }: Props) {
  const handleChange = (field: keyof CurrentRatioValues) => (e: React.ChangeEvent<HTMLInputElement>) => {
    const raw = e.target.value.replace(/\s/g, '').replace(/,/g, '');
    const value = Number(raw);
    onValuesChange(field, isNaN(value) ? 0 : value);
  };

  const inputClass = "w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500";

  return (
    <div className="space-y-6">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">{translations.currentAssets}</label>
        <input type="text" value={values.currentAssets.toLocaleString('sv-SE')} onChange={handleChange('currentAssets')} className={inputClass} placeholder="0" />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">{translations.inventory}</label>
        <input type="text" value={values.inventory.toLocaleString('sv-SE')} onChange={handleChange('inventory')} className={inputClass} placeholder="0" />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">{translations.workInProgress}</label>
        <input type="text" value={values.workInProgress.toLocaleString('sv-SE')} onChange={handleChange('workInProgress')} className={inputClass} placeholder="0" />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">{translations.currentLiabilities}</label>
        <input type="text" value={values.currentLiabilities.toLocaleString('sv-SE')} onChange={handleChange('currentLiabilities')} className={inputClass} placeholder="0" />
      </div>
    </div>
  );
}


